// Idioma del sitio (2026-10-25, ops/i18n/PLAN.md). Español sin prefijo (canónico); inglés bajo
// /en. Se decide UNA vez al arrancar (index.js) y no cambia en caliente: cambiar de idioma es
// navegar a la otra URL. Por eso el router monta con basename "/en" y TODOS los <Link to="/x">
// —también los de los expedientes congelados— se quedan en inglés sin tocarlos.
//
// Orden: prefijo en la URL > elección guardada (botón ES/EN) > idioma del navegador
// (`es*` → español; cualquier otro → inglés). Los robots no se redirigen: indexan cada URL tal cual.

const CLAVE = "yamacoa:idioma";
const ROBOT = /bot|crawl|spider|slurp|facebookexternalhit|whatsapp|telegram|preview|lighthouse/i;

const leer = () => { try { return localStorage.getItem(CLAVE); } catch { return null; } };
const guardar = (v) => { try { localStorage.setItem(CLAVE, v); } catch { /* sin almacenamiento: no pasa nada */ } };

export const enIngles = (pathname) => pathname === "/en" || pathname.startsWith("/en/");
const sinPrefijo = (pathname) => (enIngles(pathname) ? pathname.slice(3) || "/" : pathname);
const conPrefijo = (pathname) => (pathname === "/" ? "/en" : `/en${pathname}`);

// Se fija al cargar el módulo (antes que cualquier constante con tr() de otros módulos): el
// idioma de la página es el de su URL. decidirIdioma() solo decide si hay que ir a la otra.
// La copia sin conexión de una guía (scripts/exportar-guias.mjs) fija el idioma con
// window.__YAMACOA_IDIOMA, porque su ruta es un file://.
export const IDIOMA = typeof window !== "undefined"
  && (window.__YAMACOA_IDIOMA === "en" || (!window.__YAMACOA_IDIOMA && enIngles(window.location.pathname))) ? "en" : "es";

// Devuelve el idioma, o null si hay que redirigir (la página se recarga en la otra URL).
export function decidirIdioma() {
  const { pathname, search, hash } = window.location;
  // ?original: enlace explícito al texto español desde una traducción; no redirige ni cambia la elección.
  if (!enIngles(pathname) && !new URLSearchParams(search).has("original")) {
    const nav = (navigator.languages?.[0] || navigator.language || "es").toLowerCase();
    const quiere = leer() || (nav.startsWith("es") ? "es" : "en");
    if (quiere === "en" && !ROBOT.test(navigator.userAgent || "")) {
      window.location.replace(conPrefijo(pathname) + search + hash);
      return null;
    }
  }
  document.documentElement.lang = IDIOMA;
  return IDIOMA;
}

export function cambiarIdioma(nuevo) {
  guardar(nuevo);
  const { pathname, search, hash } = window.location;
  const base = sinPrefijo(pathname);
  window.location.assign((nuevo === "en" ? conPrefijo(base) : base) + search + hash);
}

// Enlace al original español de una ruta (para «Read the original»): no rebota a /en.
export const rutaOriginal = (ruta) => `${sinPrefijo(ruta)}?original`;

// Texto en línea: tr("Noticias", "News"). Sin inglés, cae al español.
export const tr = (es, en) => (IDIOMA === "en" && en != null ? en : es);
// Campo bilingüe de un dato: de(pieza, "titulo") lee pieza.en.titulo en inglés si existe.
export const de = (obj, campo) => (IDIOMA === "en" && obj?.en?.[campo] != null ? obj.en[campo] : obj?.[campo]);
// Secciones del feed (enum en español): rótulo en el idioma de la página.
const SECCIONES_EN = { "Energía": "Energy", "Economía": "Economy", "Migración": "Migration", "Salud": "Health",
  "Sociedad": "Society", "Derechos": "Rights", "Política": "Politics", "Cultura": "Culture", "Historia": "History",
  "Internacional": "International" };
export const seccion = (s) => (IDIOMA === "en" && s ? SECCIONES_EN[s] || s : s);
export const LOCALE = () => (IDIOMA === "en" ? "en-US" : "es-ES");
// Nombres de provincia para MOSTRAR: en inglés solo cambian La Habana e Isla de la Juventud; el
// resto se usa igual. Nunca para comparar (los datos y la geometría van por el nombre español o el id).
const PROVINCIAS_EN = { "La Habana": "Havana", "Ciudad de la Habana": "Havana", "Isla de la Juventud": "Isle of Youth" };
export const provincia = (n) => (IDIOMA === "en" && PROVINCIAS_EN[n]) || n;

// Los datasets de los expedientes (public/data/<tema>.json) los pide cada renderer congelado con
// fetch. En inglés se sirve public/data/en/<tema>.json si existe; si no, el español.
export function envolverFetch() {
  if (IDIOMA !== "en" || !window.fetch) return;
  const original = window.fetch.bind(window);
  const sinIngles = new Set();
  window.fetch = (entrada, opciones) => {
    const url = typeof entrada === "string" ? entrada : null;
    const m = url && url.match(/^(.*\/data\/)([a-z0-9_-]+\.json)(\?.*)?$/i);
    if (!m || /\.schema\.json$/.test(m[2]) || sinIngles.has(m[2])) return original(entrada, opciones);
    return original(`${m[1]}en/${m[2]}${m[3] || ""}`, opciones).then((r) => {
      const json = r.ok && (r.headers.get("content-type") || "").includes("json");
      if (json) return r;
      sinIngles.add(m[2]);
      return original(entrada, opciones);
    });
  };
}
